module.exports = __webpack_public_path__ + "static/themes-layers-dont-ed4665eae9aebcc1032d80f59b262040.png";